const TextToolIcon = ({ isActive, size = "24px" }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.666 2.70703C17.0112 2.70703 17.291 2.98689 17.291 3.33203V5.83203C17.291 6.17721 17.0112 6.45703 16.666 6.45703C16.3211 6.45668 16.041 6.17699 16.041 5.83203V3.95703H10.625V16.04H12.5C12.845 16.04 13.1248 16.32 13.125 16.665C13.125 17.0102 12.8452 17.29 12.5 17.29H7.5C7.15482 17.29 6.875 17.0102 6.875 16.665C6.87522 16.32 7.15496 16.04 7.5 16.04H9.375V3.95703H3.95801V5.83203C3.95801 6.17721 3.67819 6.45703 3.33301 6.45703C2.98798 6.45686 2.70801 6.1771 2.70801 5.83203V3.33203C2.70805 2.987 2.988 2.70721 3.33301 2.70703H16.666Z"
        fill={finalColor}
      />
    </svg>
  );
};

export default TextToolIcon;
